export default {
  partner: {
    chart_data_group: ['global', 'email', 'use'],
    chart_data_values: {
      global: [
        'visit',
        'email',
        'comment',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'histomaton_file',
        'affluence',
        'survey_answer',
        'route_duration',
      ],
      email: [
        'email_delivered',
        'email_open',
        'email_click',
        'email_delivered_session',
        'email_open_session',
        'email_click_session',
      ],
      use: [
        'hotspot',
        'cartel',
        'immersive',
        'augmentedvisit',
        'interactiveobject',
        'interactivebuilding',
      ],
    },
    chart_data_types: {
      visit: ['count', 'average_count', 'average_time', 'distribution'],
      email: ['count', 'average_count', 'distribution', 'percentage'],
      comment: ['count', 'average_count', 'distribution', 'percentage'],
      histopad_rating: ['average_count', 'percentage'],
      visit_rating: ['average_count', 'percentage'],
      collected_treasure_count: ['count', 'average_count', 'distribution'],
      histomaton_file: ['count', 'average_count', 'percentage', 'distribution'],
      affluence: ['count', 'average_count'],
      survey_answer: ['count', 'average_count', 'percentage', 'distribution'],
      route_duration: ['average_time', 'percentage'],
      hotspot: ['count', 'average_count'],
      cartel: ['count', 'average_count', 'average_time'],
      immersive: ['count', 'average_count', 'average_time'],
      augmentedvisit: ['count', 'average_count', 'average_time'],
      interactiveobject: ['count', 'average_count', 'average_time'],
      interactivebuilding: ['count', 'average_count', 'average_time'],
      sequence: ['count', 'average_count', 'average_time'],
      interactivecharacter: ['count', 'average_count', 'average_time'],
      email_delivered: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_open: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_click: ['count', 'average_count', 'percentage', 'distribution'],
      email_delivered_session: [
        'count',
        'average_count',
        'average_time',
        'percentage',
        'distribution',
      ],
      email_open_session: ['count', 'average_count', 'average_time', 'percentage', 'distribution'],
      email_click_session: ['count', 'average_count', 'percentage', 'distribution'],
    },
    chart_distribution_types: {
      visit: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'duration',
        'product',
      ],
      email: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      comment: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      collected_treasure_count: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'product',
      ],
      histopad_rating: [
        'site_location',
        'language',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      visit_rating: [
        'site_location',
        'language',
        'histopad_rating',
        'collected_treasure_count',
        'product',
      ],
      hotspot: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      cartel: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      augmentedvisit: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      interactiveobject: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      interactivebuilding: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      sequence: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      interactivecharacter: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
      ],
      histomaton_file: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      survey_answer: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_delivered: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_open: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_click: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_delivered_session: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_open_session: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
      email_click_session: [
        'site_location',
        'language',
        'histopad_rating',
        'visit_rating',
        'collected_treasure_count',
        'product',
      ],
    },
    charts: {
      count: ['time', 'indicator', 'day'],
      average_count: ['time', 'indicator'],
      average_time: ['time', 'indicator'],
      percentage: ['time', 'indicator'],
      distribution: ['pie', 'bar'],
    },
    sort_by_values: [
      'all',
      'site_location',
      'language',
      'histopad_rating',
      'visit_rating',
      'collected_treasure_count',
      'product',
    ],
  },
}
